import { Link } from 'react-router-dom';
import type { Character } from '@/mocks/characters';
import ElementTag from '@/components/base/ElementTag';

interface CharacterCardProps {
  character: Character;
}

export default function CharacterCard({ character }: CharacterCardProps) {
  return (
    <Link
      to={`/detail/${character.guideId}`}
      className="group card-hover relative block overflow-hidden rounded-lg border border-background-200 bg-background-50 hover:border-primary-300"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={character.avatar}
          alt={`原神角色${character.name}立绘`}
          className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent"></div>
        <div className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-black/45 px-2 py-1 text-xs font-medium text-amber-300 backdrop-blur-sm">
          {Array.from({ length: character.rarity }).map((_, i) => (
            <i key={i} className="ri-star-fill"></i>
          ))}
        </div>
        <div className="absolute inset-x-0 bottom-0 p-3.5">
          <h3 className="font-heading text-lg font-bold text-white">{character.name}</h3>
          <div className="mt-1.5 flex items-center flex-wrap gap-2">
            <ElementTag element={character.element} />
            <span className="inline-flex items-center gap-1 rounded-full bg-white/20 px-2 py-0.5 text-xs font-medium text-white backdrop-blur-sm">
              <i className="ri-sword-line"></i>
              {character.weapon}
            </span>
          </div>
        </div>
        <div className="absolute inset-0 flex items-end bg-primary-950/70 p-4 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <p className="text-xs leading-relaxed text-background-50 line-clamp-5">{character.intro}</p>
        </div>
      </div>
      <div className="flex items-center justify-between gap-2 px-3.5 py-3">
        <span className="inline-flex items-center gap-1 text-xs text-foreground-600">
          <i className="ri-map-pin-line"></i>
          {character.region}
        </span>
        <span className="truncate text-xs font-medium text-secondary-600">{character.role}</span>
      </div>
    </Link>
  );
}